import { useCallback, useRef } from 'react';

function uuid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/**
 * Idempotency-Key je logischer Startaktion: Wiederholung desselben Klicks mit gleicher
 * Nutzlast (z. B. nach Netzfehler) nutzt denselben Schlüssel; neue Nutzlast oder
 * abgeschlossene Aktion erzeugt einen neuen.
 */
export function useIdempotencyKey() {
  const ref = useRef<{ fingerprint: string; key: string } | null>(null);
  const keyFor = useCallback((payload: unknown) => {
    const fingerprint = JSON.stringify(payload ?? null);
    if (!ref.current || ref.current.fingerprint !== fingerprint) ref.current = { fingerprint, key: uuid() };
    return ref.current.key;
  }, []);
  const reset = useCallback(() => {
    ref.current = null;
  }, []);
  return { keyFor, reset };
}

export { uuid };
